export const cancelButton = "i22xIc";
export default {cancelButton};